var app = angular.module('App', []);

app.controller('AppCtrl', ['$scope', '$interval', '$timeout', function($scope, $interval, $timeout) {

  $scope.data = {
    "questions": [{
      "id": 01,
      "options": [{
        "name": "Niki Lauda",
        "solution": true,
      }, {
        "name": "James Hunt",
        "solution": false,

      }, {
        "name": "Ronnie Petterson",
        "solution": false,

      }],
      "teams": [{
        "id": 1,
        "club": "March",
        "img": "march",
      }, {
        "id": 2,
        "club": "BRM",
        "img": "brm",

      }, {
        "id": 3,
        "club": "Ferrari",
        "img": "ferrari",

      }, {
        "id": 4,
        "club": "Brabham",
        "img": "brabham",

      }, {
        "id": 5,
        "club": "McLaren",
        "img": "mclaren",
      }],
      "correctImg": "niki-lauda.png",
      "wrongImg": "01.png",
    }, {
      "id": 02,
      "options": [{
        "name": "Keke Rosberg",
        "solution": false,
      }, {
        "name": "René Arnoux",
        "solution": false,

      }, {
        "name": "Stefan Johansson",
        "solution": true,

      }],
      "teams": [{
        "id": 1,
        "club": "Shadow",
        "img": "shadow",
      }, {
        "id": 2,
        "club": "Spirit",
        "img": "spirit",

      }, {
        "id": 3,
        "club": "Tyrrell",
        "img": "tyrrell",

      }, {
        "id": 4,
        "club": "Toleman",
        "img": "toleman",

      }, {
        "id": 5,
        "club": "Tyrrell",
        "img": "tyrrell",

      }, {
        "id": 6,
        "club": "McLaren",
        "img": "mclaren",

      }, {
        "id": 7,
        "club": "Ligier",
        "img": "ligier",

      }],
      "correctImg": "stefan-johansson.png",
      "wrongImg": "02.png",
    }, {
      "id": 03,
      "options": [{
        "name": "Sebastian Vettel",
        "solution": true,
      }, {
        "name": "Robert Kubica",
        "solution": false,

      }, {
        "name": "Jenson Button",
        "solution": false,

      }],
      "teams": [{
        "id": 1,
        "club": "BMW Sauber",
        "img": "bmw",
      }, {
        "id": 2,
        "club": "Toro Rosso",
        "img": "toro-rosso",

      }, {
        "id": 3,
        "club": "Red Bull",
        "img": "red-bull",

      }, {
        "id": 4,
        "club": "Ferrari",
        "img": "ferrari",

      }],
      "correctImg": "sebastian-vettel.png",
      "wrongImg": "03.png",
    }, {
      "id": 04,
      "options": [{
        "name": "Lewis Hamilton",
        "solution": false,
      }, {
        "name": "Felipe Massa",
        "solution": false,

      }, {
        "name": "Jenson Button",
        "solution": true,

      }],
      "teams": [{
        "id": 1,
        "club": "Williams",
        "img": "williams",
      }, {
        "id": 2,
        "club": "Benneton",
        "img": "benetton",
      }, {
        "id": 3,
        "club": "Renault",
        "img": "renault",
      }, {
        "id": 4,
        "club": "BAR",
        "img": "bar",
      }, {
        "id": 5,
        "club": "Honda",
        "img": "honda",

      }, {
        "id": 6,
        "club": "Brawn GP",
        "img": "brawn-gp",

      }, {
        "id": 7,
        "club": "McLaren",
        "img": "mclaren",

      }],
      "correctImg": "jenson-button.png",
      "wrongImg": "04.png",
    }, {
      "id": 05,
      "options": [{
        "name": "Ayrton Senna",
        "solution": true,
      }, {
        "name": "Stefan Bellof",
        "solution": false,

      }, {
        "name": "Nigel Mansell",
        "solution": false,

      }],
      "teams": [{
        "id": 1,
        "club": "Toleman",
        "img": "toleman",
      }, {
        "id": 2,
        "club": "Lotus",
        "img": "lotus",

      }, {
        "id": 3,
        "club": "McLaren",
        "img": "mclaren",

      }, {
        "id": 4,
        "club": "williams",
        "img": "williams",

      }],
      "correctImg": "ayrton-senna.png",
      "wrongImg": "05.png",
    }, {
      "id": 06,
      "options": [{
        "name": "Jos Verstappen",
        "solution": false,
      }, {
        "name": "Felipe Massa",
        "solution": false,
      }, {
        "name": "Fernando Alonso",
        "solution": true,
      }],
      "teams": [{
        "id": 1,
        "club": "Minardi",
        "img": "minardi",
      }, {
        "id": 2,
        "club": "Renault",
        "img": "renault",

      }, {
        "id": 3,
        "club": "McLaren",
        "img": "mclaren",

      }, {
        "id": 4,
        "club": "Renault",
        "img": "renault",

      }, {
        "id": 5,
        "club": "Ferrari",
        "img": "ferrari",

      }, {
        "id": 6,
        "club": "McLaren",
        "img": "mclaren",

      }],
      "correctImg": "fernando-alonso.png",
      "wrongImg": "06.png",
    }, {
      "id": 07,
      "options": [{
        "name": "Nick Heidfeld",
        "solution": false,
      }, {
        "name": "Felipe Massa",
        "solution": true,

      }, {
        "name": "Heinz Harald Frentzen",
        "solution": false,

      }],
      "teams": [{
        "id": 1,
        "club": "Sauber",
        "img": "sauber",
      }, {
        "id": 2,
        "club": "Ferrari",
        "img": "ferrari",

      }, {
        "id": 3,
        "club": "Sauber",
        "img": "sauber",
      }, {
        "id": 4,
        "club": "Ferrari",
        "img": "ferrari",

      }, {
        "id": 5,
        "club": "Williams",
        "img": "williams",

      }],
      "correctImg": "felipe-massa.png",
      "wrongImg": "07.png",
    }, {
      "id": 08,
      "options": [{
        "name": "Jim Clark",
        "solution": false,
      }, {
        "name": "Graham Hill",
        "solution": false,

      }, {
        "name": "Jackie Stewart",
        "solution": true,

      }],
      "teams": [{
        "id": 1,
        "club": "Lotus",
        "img": "lotus",
      }, {
        "id": 2,
        "club": "BRM",
        "img": "brm",

      }, {
        "id": 3,
        "club": "Matra",
        "img": "matra",

      }, {
        "id": 4,
        "club": "Tyrrell",
        "img": "tyrrell",

      }],
      "correctImg": "jackie-stewart.png",
      "wrongImg": "08.png",
    }, {
      "id": 09,
      "options": [{
        "name": "Michael Schumacher",
        "solution": true,
      }, {
        "name": "Andrea de Cesaris",
        "solution": false,

      }, {
        "name": "Nelson Piquet",
        "solution": false,

      }],
      "teams": [{
        "id": 1,
        "club": "Jordan",
        "img": "jordan",
      }, {
        "id": 2,
        "club": "Bennetton",
        "img": "benetton",
      }, {
        "id": 3,
        "club": "Ferrari",
        "img": "ferrari",

      }, {
        "id": 4,
        "club": "Mercedes",
        "img": "mercedes",

      }],
      "correctImg": "michael-schumachers.png",
      "wrongImg": "09.png",
    }, {
      "id": 10,
      "options": [{
        "name": "Nigel Mansell",
        "solution": true,
      }, {
        "name": "Mario Andretti",
        "solution": false,

      }, {
        "name": "Elio de Angelis",
        "solution": false,

      }],
      "teams": [{
        "id": 1,
        "club": "Lotus",
        "img": "lotus",
      }, {
        "id": 2,
        "club": "Williams",
        "img": "williams",

      }, {
        "id": 3,
        "club": "Ferrari",
        "img": "ferrari",

      }, {
        "id": 4,
        "club": "Williams",
        "img": "williams",

      }, {
        "id": 5,
        "club": "McLaren",
        "img": "mclaren",

      }],
      "correctImg": "nigel-mansell.png",
      "wrongImg": "10.png",
    }, {
      "id": 11,
      "options": [{
        "name": "Jean Alesi",
        "solution": false,
      }, {
        "name": "Eric Bernard",
        "solution": false,

      }, {
        "name": "Jos Verstappen",
        "solution": true,

      }],
      "teams": [{
        "id": 1,
        "club": "Bennetton",
        "img": "benetton",
      }, {
        "id": 2,
        "club": "Simtek",
        "img": "simtek",

      }, {
        "id": 3,
        "club": "Footwork Arrows",
        "img": "footwork",
      }, {
        "id": 4,
        "club": "Tyrrell",
        "img": "tyrrell",

      }, {
        "id": 5,
        "club": "Stewart",
        "img": "stewart",

      }, {
        "id": 6,
        "club": "Honda",
        "img": "honda",

      }, {
        "id": 7,
        "club": "Footwork Arrows",
        "img": "footwork",

      }, {
        "id": 8,
        "club": "Minardi",
        "img": "minardi",

      }],
      "correctImg": "jos-verstappen1.png",
      "wrongImg": "01.png",
    }, {
      "id": 12,
      "options": [{
        "name": "Ronnie Peterson",
        "solution": true,
      }, {
        "name": "Chris Amon",
        "solution": false,

      }, {
        "name": "Jackie Stewart",
        "solution": false,

      }],
      "teams": [{
        "id": 1,
        "club": "Antique Automobiles Racing Team",
        "img": "aart",
      }, {
        "id": 2,
        "club": "March",
        "img": "march",

      }, {
        "id": 3,
        "club": "Lotus",
        "img": "lotus",

      }, {
        "id": 4,
        "club": "March",
        "img": "march",

      }, {
        "id": 5,
        "club": "Tyrrell",
        "img": "tyrrell",

      }, {
        "id": 6,
        "club": "Lotus",
        "img": "lotus",

      }],
      "correctImg": "ronnie-peterson.png",
      "wrongImg": "02.png",
    }]
  };
  $scope.questions = $scope.data.questions;
  //RANDOMIZE ORDER OF QUESTIONS
  $scope.questions.sort(function() {
    return 0.5 - Math.random()
  });

  //VARIABLES
  var scoreTimer = 120,
    viewTimer = 2000,
    runTimer = false,
    correctImg, wrongImg, scoreAdjustment;
  //SCOPED VARIABLES
  $scope.progressPercentage = 0;
  $scope.pageNumber = 1;
  $scope.page = 1;
  $scope.rightanswer = 0;
  $scope.wronganswer = 0;
  $scope.point = 0;
  $scope.revealClue = 1;
  $scope.roundPoint = 0;
  $scope.price = 4;
  $scope.correctLoaded = false;
  $scope.wrongLoaded = false;
  $scope.loaded = false;
  $scope.backgroundimage;
  $scope.view = 'startscreen';
  $scope.preview = 'tutorial';
  $scope.leaveView = '';
  $scope.maxPages = $scope.questions.length;
  $scope.reply = '';
  $scope.imgUrl = 'https://static.ekstrabladet.dk/redaktioneludvikling/data/images/2016/formulaone-quiz/drivers/';
  $scope.graphicUrl = 'https://static.ekstrabladet.dk/redaktioneludvikling//data/graphics/2016/f1logos/';
  // Img preloader
  $scope.backgroundimage = new Image();
  $scope.backgroundimage.src = 'https://static.ekstrabladet.dk/redaktioneludvikling/data/dropper/2016/7a333600-d573-11e5-8b6e-3f14f06092bf.png';
  $scope.correctImg = $scope.imgUrl + $scope.questions[$scope.page - 1].correctImg;
  $scope.wrongImg = $scope.imgUrl + $scope.questions[$scope.page - 1].wrongImg;

  $scope.backgroundimage.onload = function() {
    angular.forEach($scope.questions, function(value, key) {
      correctImg = new Image();
      wrongImg = new Image();
      correctImg.src = $scope.imgUrl + value.correctImg;
      wrongImg.src = $scope.imgUrl + value.wrongImg;

      if (key === 2) {
        correctImg.onload = function() {
          $scope.correctLoaded = true;

          if ($scope.wrongLoaded) {
            $scope.$apply(function() {
              $scope.loaded = true;
            });
          }
        }
        wrongImg.onload = function() {
          $scope.wrongLoaded = true;

          if ($scope.correctLoaded) {
            $scope.$apply(function() {
              $scope.loaded = true;
            });
          }
        }
      }
    });
  }

  //CALCULATES TIMEINTERVAL FOR REVEALING OF CLUES
  var sliceIt = function() {
    $scope.clueCount = $scope.questions[$scope.pageNumber - 1].teams.length;
    clueInterval = Math.round(100 / $scope.clueCount);

    //CALCULATING INTERVAL BETWEEN EACH CLUE IS REVEALED
    scoreAdjustment = $interval(function() {
      if ($scope.progressPercentage < 100 && $scope.view === 'quizscreen' && runTimer === true) {
        $scope.progressPercentage += 1;
        $scope.barWidth = $scope.progressPercentage + '%';

        if ($scope.progressPercentage === 25) {
          $scope.price--;
        }

        if ($scope.progressPercentage === 50) {
          $scope.price--;
        }

        if ($scope.progressPercentage === 75) {
          $scope.price--;
        }

        if ($scope.progressPercentage === (clueInterval * $scope.revealClue)) {
          if ($scope.revealClue < $scope.clueCount) {
            $scope.revealClue++;
          }
        }
      }
    }, scoreTimer);
  };

  $scope.tutorial = function() {
      $scope.leaveView = 'startscreen';
      $scope.view = 'tutorial';
      $scope.preview = 'quizscreen';
    }
    //START QUIZ
  $scope.start = function() {
    runTimer = true;
    $scope.leaveView = $scope.view;
    $scope.view = 'quizscreen';
    $scope.preview = 'midscreen';
    $scope.questions[$scope.pageNumber - 1].options.sort(function() {
      return 0.5 - Math.random()
    });

    sliceIt();
  }

  //WHEN ANWSERING QUETIONS
  $scope.answer = function(val) {
    if (runTimer) {
      runTimer = false;
      $scope.hideTutorial = true;

      $interval.cancel(scoreAdjustment);

      $scope.barWidth = '0%';
      $scope.progressPercentage = 0;
      $scope.revealClue = 1;

      $scope.leaveView = $scope.view;
      $scope.view = 'midscreen';
      $scope.preview = '';

      $timeout(function() {
        $scope.preview = 'quizscreen';
        $scope.leaveView = '';
      }, 500);

      //CORRECT ANSWER
      if (val === true) {
        $scope.reply = 'Rigtigt!';
        $scope.roundPoint = $scope.price;
        $scope.rightanswer += 1;
        $scope.point += $scope.price;
      } else {
        $scope.reply = 'Forkert!';
        $scope.roundPoint = 0;
        $scope.wronganswer++;
      }

      //IF LAST PAGE -  SWITCH TO FINAL SCREEN
      if ($scope.pageNumber == $scope.questions.length) {
        $timeout(function() {
          $scope.leaveView = 'midscreen';
          $scope.view = 'finalscreen';
        }, viewTimer);
      }

      //SWITCH BACK TO QUESTIONS VIEW
      //RESET SETTINGS
      $timeout(function() {
        //RE-CALCULATES INTERAL SIZE FOR EACH CLUE
        $scope.pageNumber++;

        sliceIt();

        $scope.view = 'quizscreen';
        $scope.leaveView = 'midscreen';
        $scope.preview = '';
        $scope.price = 4;

        $timeout(function() {
          $scope.page++;
          $scope.correctImg = $scope.imgUrl + $scope.questions[$scope.page - 1].correctImg;
          $scope.wrongImg = $scope.imgUrl + $scope.questions[$scope.page - 1].wrongImg;
          $scope.preview = 'midscreen';
          $scope.leaveView = '';
          runTimer = true;
        }, 500)
      }, viewTimer);
    };
  };

  //PARTIAL DIRECTIVES
}]).directive('questions', function() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'directives/questions.html'
  };
}).directive('midscreen', function() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'directives/midscreen.html'
  };
}).directive('clues', function() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'directives/clues.html'
  };
}).directive('end', function() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'directives/end.html'
  };
}).directive('start', function() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'directives/start.html'
  };
}).directive('tutorial', function() {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: 'directives/tutorial.html'
  };
});
